import { css, cx } from 'emotion';
import {
	museo900,
	textBlock,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const animate = css({
	transition: 'all 0.125s ease-in-out',
	position: 'relative',
	'&:after': {
		transition: 'all 0.125s ease-in-out',
		position: 'absolute',
		bottom: '0px',
		left: '10%',
		width: '80%',
		borderRadius: '3px',
		height: '5px',
		background: '#fff',
		content: "' '",
		opacity: 0,
	},
});

export const arrowIconStyle = css({
	position: 'absolute',
	bottom: '36px',
	left: '24px',
	transition: 'all 0.125s ease-in-out',

	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		position: 'relative',
		bottom: 'initial',
		left: 'initial',
	},
});

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
});

export const wrapperStyle = (background, animateVowel, minHeight) =>
	css({
		padding: '36px 24px',
		background: background,
		borderRadius: '8px',
		boxShadow: '0 6px 12px 0 rgba(0,0,0,0.18)',
		minHeight: minHeight,
		paddingBottom: '76px',
		boxSizing: 'border-box',
		position: 'relative',
		height: '100%',
		transition: 'all 0.125s ease-in-out',

		'& h1': animateVowel
			? {
					'& > span': {
						float: 'left',
						'& > span': {
							display: 'inline-block',
						},
						'&:not(:last-child):after': {
							content: "' '",
							fontSize: 'inherit',
							whiteSpace: 'pre',
						},
					},
					'&:after': {
						display: 'block',
						content: "' '",
						clear: 'both',
					},
			  }
			: {},
		'&:hover': {
			[`@media (min-width: ${ tabletPortraitMaxWidthBreakpoint + 1 }px)`]: {
				transform: 'translateY(-4px)',
				boxShadow: '0 8px 12px 0 rgba(0,0,0,0.4)',
			},

			'& h1': animateVowel
				? {
						[`& .${animate}`]: {
							overflow: 'visible',
							transform: 'translateY(-7px)',
							'&:after': {
								opacity: 1,
							},
						},
				  }
				: null,
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			padding: '14px',
			minHeight: 'auto',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			backgroundImage: 'none',
		},
	});

export const titleStyle = css({
	...museo900,
	textTransform: 'uppercase',
	fontWeight: 'normal',
	fontSize: '28px',
	lineHeight: '34px',
	marginTop: 0,
	color: '#fff',
	marginBottom: '11px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		position: 'relative',
		bottom: '-2px', // font variance
		fontSize: '16px',
		lineHeight: '19px',
		marginRight: '14px',
		margin: '0',
	},
});

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: 0,
		marginBottom: '10px',
		color: '#fff',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			display: 'none',
		},
	})
);

export const compressedStyle = css({
	[`& .${titleStyle}`]: {
		position: 'relative',
		bottom: '-2px', // font variance
		fontSize: '16px',
		lineHeight: '19px',
		marginRight: '14px',
		margin: '0',
	},
});

export const compressedOneColumnStyle = css({
	minHeight: 'auto',
});

export const minimizedStyle = css({
	padding: '14px',
	minHeight: 'auto',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	backgroundImage: 'none',

	[`& .${bodyStyle}`]: {
		display: 'none',
	},

	[`& .${arrowIconStyle}`]: {
		position: 'relative',
		bottom: 'initial',
		left: 'initial',
	},

	[`& .${titleStyle}`]: {
		position: 'relative',
		bottom: '-2px', // font variance
		fontSize: '16px',
		lineHeight: '19px',
		marginRight: '14px',
		margin: '0',
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/colouredCard/styles.js